(ns vit-configurator.views
  (:require [clojure.string :as str]
            [re-frame.core :as re-frame]
            [reagent.core :as reagent]
            [vit-configurator.events :as events]
            [vit-configurator.subs :as subs]
            [vit-configurator.views.analytics :as analytics]
            [vit-configurator.views.voter-info :as vi]
            [vit-configurator.views.intro :as intro]
            [vit-configurator.views.language :as language]
            [vit-configurator.views.links :as links]
            [vit-configurator.views.logo :as logo]
            [vit-configurator.views.official :as official]
            [vit-configurator.views.size :as size]
            [vit-configurator.views.summary :as summary]
            [vit-configurator.views.title :as title]
            [vit-configurator.auth :as auth]))

(defn size-str [size]
  (case size
    :responsive "min-width: 360px; max-width: 640px; height: 480px;"
    :large-responsive "min-width: 360px; max-width: 960px; height: 480px;"
    :search-box-only "min-width: 360px; max-width: 640px;"
    :container-responsive ""
    :small "width: 360px; height: 480px;"
    :regular "width: 640px; height: 480px;"
    :full "width: 100%; height: 480px;"
    "min-width: 360px, max-width: 640px; height: 480px;"))

(defn official-only-snippet [official-only]
  (str "    \"official-only\": " (.stringify js/JSON official-only)))

(defn code-snippet
  [{:keys [title embedded-line1 embedded-line1-hidden embedded-line2 embedded-line2-hidden embedded-line3 embedded-line3-hidden 
           summary-top-txt summary-bottom-txt summary-vote-by-mail-txt summary-absentee-hidden logo language official-only links size
           search-box-type voter-info google-analytics-tracker]}]
  (str
   "<link rel=\"stylesheet\" type=\"text/css\" href=\"https://votinginfotool.org/css/compiled/vit.css\"/>\n"
   "<script src=\"https://votinginfotool.org/js/compiled/app.js\"></script>\n"
   (cond
     (= search-box-type :search)
     (str "<div id=\"_vit-search\" style=\"min-width: 360px; max-width: 640px; width: 100%;\"></div>\n")
     
     (= size :container-responsive)
     (str "<div id=\"vit-size-container\" class=\"vit-size-container\" style=\"width: 100%; height: 100%;\">\n"
          "  <div id=\"_vit\"></div>\n</div>\n")
     :else
     (str "<div id=\"_vit\" style=\"" (size-str size) "\"></div>\n"))
   "<script>\n"
   "  var config = {\n"
   (when-not (str/blank? (:en title))
     (str "    \"title\": " (.stringify js/JSON (clj->js title)) ",\n"))
   (when-not (str/blank? (:en embedded-line1))
     (str "    \"embedded-line1\": " (.stringify js/JSON (clj->js embedded-line1)) ",\n"))
   (when embedded-line1-hidden
     (str "    \"embedded-line1-hidden\": " (.stringify js/JSON (clj->js embedded-line1-hidden)) ",\n"))
   (when-not (str/blank? (:en embedded-line2))
     (str "    \"embedded-line2\": " (.stringify js/JSON (clj->js embedded-line2)) ",\n"))
   (when embedded-line2-hidden
     (str "    \"embedded-line2-hidden\": " (.stringify js/JSON (clj->js embedded-line2-hidden)) ",\n"))
   (when-not (str/blank? (:en embedded-line3))
     (str "    \"embedded-line3\": " (.stringify js/JSON (clj->js embedded-line3)) ",\n"))
   (when embedded-line3-hidden
     (str "    \"embedded-line3-hidden\": " (.stringify js/JSON (clj->js embedded-line3-hidden)) ",\n"))
   (when-not (str/blank? (:en voter-info))
     (str "    \"voter-info\": " (.stringify js/JSON (clj->js voter-info)) ",\n"))
   "    \"logo\": " (.stringify js/JSON (clj->js logo)) ",\n"
   (when-not (str/blank? (:en summary-top-txt))
     (str "    \"summary-top-txt\": " (.stringify js/JSON (clj->js summary-top-txt)) ",\n"))
   (when-not (str/blank? (:en summary-bottom-txt))
     (str "    \"summary-bottom-txt\": " (.stringify js/JSON (clj->js summary-bottom-txt)) ",\n"))
   (when-not (str/blank? (:en summary-vote-by-mail-txt))
     (str "    \"summary-vote-by-mail-txt\": " (.stringify js/JSON (clj->js summary-vote-by-mail-txt)) ",\n"))
   (when summary-absentee-hidden
     (str "    \"summary-absentee-hidden\": " (.stringify js/JSON (clj->js summary-absentee-hidden)) ",\n"))
   (when language
     (str "    \"language\": " (.stringify js/JSON (name language)) ",\n"))
   (when (= search-box-type :search)
     (str "    \"search-box-only?\": true,\n"))
   (when google-analytics-tracker
     (str "    \"google-analytics-tracker\": " (.stringify js/JSON google-analytics-tracker) ",\n"))
   (official-only-snippet official-only)
   (when (seq links)
     (str ",\n    \"links\": " (.stringify js/JSON (clj->js links))))
   "\n  };\n"
   "  var loadVIT = function () {\n"
   "    if (typeof vit !== 'undefined'){\n"
   "      vit.core.init(\"" (if (= search-box-type :search) "_vit-search" "_vit") "\", config);\n"
   "    } else {\n"
   "      setTimeout(loadVIT, 500);\n"
   "    };\n"
   "  };\n"
   "  loadVIT();\n"
   "</script>"))

(defn open-card
  [title-str key-val content]
  [:div.card.borderless.mb-2.pb-0 {:key (gensym key-val)}
   [:div.card-body
    (when title-str
      [:p.card-title.font-weight-bold
       [:span title-str]])
    [:div.gttp-card-text-wrapper.small
     content]]])

(defn card
  [title-str key-val initially-closed? content]
  (let [card-closed? (reagent/atom initially-closed?)]
    ;;Note: we only care about initially-closed? on the initial outer call,
    ;;so we ignore the parameter in the render function below /shrug
    (fn [title-str key-val _ content]
      [:div.card.borderless.mb-2.pb-0 {:key (gensym key-val)}
       [:div.card-body.p-3
        [:p.card-title.font-weight-bold.mb-0
         [:span title-str]
         [:i.material-icons.text-medium-gray.toggle-card
          {:on-click #(swap! card-closed? not)}
          (if @card-closed? "keyboard_arrow_down" "keyboard_arrow_up")]]
        [:div.gttp-card-text-wrapper.small.mt-2
         {:class (if @card-closed? "d-none" "d-block")}
         content]]])))

(defn code-to-clipboard
  "Code here cribbed from:
  https://www.w3schools.com/howto/howto_js_copy_clipboard.asp.
  The textarea is styled to be visible but placed off screen, because
  you can't copy from a hidden element."
  []
  (let [codebox (. js/document getElementById "_vit_copy_code")]
    (. codebox select)
    (. codebox setSelectionRange 0 99999)
    (. js/document execCommand "copy")
    (js/alert "Copied")))

(defn preview-size [size search-box-type]
  (cond
    (= search-box-type :search)
    {:width "700px"
     :height "500px"}

    (= size :small)
    {:width "400px"
     :height "500px"}

    (= size :large-responsive)
    {:width "980px"
     :height "500px"}

    (= size :full)
    {:width "100%"
     :height "500px"}
    
    :else
    {:width "700px"
     :height "500px"}))

(defn code
  []
  (let [clj-config @(re-frame/subscribe [::subs/clj-config])
        snippet   (code-snippet clj-config)]
    [:<>
     [:h4.pt-4 "Customized Embed Code"]
     [:p.small "The box below contains your custom embed code. "
      "You'll need to copy all the contents, and put them in the HTML page "
      "where you want the Voter Information Tool to show up. "
      "You can copy the contents automatically using the Copy to Clipboard button, "
      "and then paste them into your page directly, or send them on to your website maintainer."]
     [open-card nil :embed
      [:div
       [:pre.p-2.border.border-black
        [:code {:id "_vit_code"} snippet]]
       [:textarea._vit_code_copy
        {:id "_vit_copy_code"
         :readOnly true
         :value snippet}]
       [:div
        [:button.btn.inline.left {:on-click code-to-clipboard} "Copy to Clipboard"]]]]]))

(defn main-panel []
  (let [search-box-type @(re-frame/subscribe [::subs/search-box-type])
        size (:size @(re-frame/subscribe [::subs/clj-config]))
        vit-preview-env @(re-frame/subscribe [::subs/vit-preview-env])]
    [:<>
     [:div.col-4.d-flex.flex-column
      [:h4.pt-4 "Configure"]
      [:p.small.mb-3
       [:a {:href "https://www.votinginfoproject.org/tools/widgets" :target "_blank"} "Learn more about the Voting Information Tool"]]
      [card "Type" :size false [size/customizer search-box-type]]
      (when (not= search-box-type :search)
        [card "Logo" :logo true [logo/customizer]])
      (when (not= search-box-type :search)
        [card "Landing Page Title" :title true [title/customizer]])
      (when (not= search-box-type :search)
        [card "Landing Page Text" :intro true [intro/customizer]])
      [card "Voter Information Message" :voter-info true [vi/customizer]]
      [card "Voting Options Summary Page" :language true [summary/customizer]]
      [card "Language" :language true [language/customizer]]
      [card "Official data use" :official-data true [official/customizer]]
      [card "Custom Election Info links" :links true [links/customizer]]
      [card "Google Analytics" :analytics true [analytics/customizer]]
      [:div
       [:button.reload_preview.btn
        {:on-click #(re-frame/dispatch [::events/save-config-and-reload-preview])}
        "Save and Update Configuration"]]]
     [:div.col-8.d-flex.flex-column
      [:h4.pt-4 "Preview"]
      [:div.container.d-flex.justify-content-center]
      [:p.small
       "You can preview your configuration changes in the sample tool below. "
       "Just make your changes in the left hand side and then click one of the \"Save and Update Configuration\" buttons to load the changes into the sample tool and code block below. "]
       [:p.small
        [:i
         "If you've made " [:strong "Voter Information Message"]
         " or " [:strong "Custom Link"]
         " changes, you should type " [:strong ":preview"]
         " or " [:strong ":mail-preview"]
         " into the address field and click on the Search button in order to see those in mocked results."]
        " Voter Information Messages appear after a search but before results, and custom link texts appear on the Contact Info tab."]
      [:iframe#live_preview {:src (if (= vit-preview-env "staging")
                                    "staging-preview.html"
                                    "live-preview.html")
                             :style (preview-size size search-box-type)}]
      [code]]]))

(defn login-panel-base [content]
  [:div.col-4.d-flex.flex-column
   [:h4.pt-4 "Sign-in"]
   [open-card nil :sign-in content]])

(defn login-panel []
  (login-panel-base
   [:div
    [:p
     "An account is now required to access the "
     [:a {:href "https://www.votinginfoproject.org/tools/widgets" :target "_blank"}
      "Voting Information Tool Widget Customizer"]
     "."]
    [:div [:button.btn.mb-3 {:on-click auth/auth0-login} "Sign-in"]]
    [:p.mb-0
     [:a.divided-text {:href "https://www.votinginfoproject.org/tools/widgets/customizer/access" :target "_blank"}
      "Request access"]
     [:a {:href "https://www.votinginfoproject.org/tools/widgets" :target "_blank"}
      "Learn more"]]]))

(defn unauthorized-panel []
  (login-panel-base
   [:<>
    [:p "You are not authorized to access the "
     [:a {:href "https://www.votinginfoproject.org/tools/widgets" :target "_blank"} "Voting Information Tool Widget Customizer"]
     "."]
    [:p.mb-0
     "Contact "
     [:a {:href "mailto:info@votinginfoproject.org"} "info@votinginfoproject.org"]
     " for access."]]))

(defn loading-panel []
  (login-panel-base [:button.btn "Signing in..."]))

(defn home-panel []
  (let [auth-required? @(re-frame/subscribe [::subs/auth-required?])
        authenticated? @(re-frame/subscribe [::subs/authenticated?])
        user @(re-frame/subscribe [::subs/user])
        loading? (or @(re-frame/subscribe [::subs/auth-loading?]) @(re-frame/subscribe [::subs/user-loading?]))]
    [:div.container
     [:div.row.bg-white.justify-content-start {:style {"marginBottom" "4px"}}
      [:div
       [:div.m-3.float-left [:img {:src "https://assets.democracy.works/img/vit-configurator/logo-purple.png" :width "75px" :height "auto" }]]
       [:div.mt-4.inline-block
        [:h6.text-uppercase [:a {:href "https://votinginfotool.org" :target "_blank"} "Voting Information Tool"]]
        [:h3 "Widget Customizer"]]]
      (when (= true authenticated?)
        [:div.mt-2.ml-auto.mr-3
         [:p.mb-2.small (:email user)]
         [:button.btn.ml-auto {:on-click #(re-frame/dispatch [::auth/logout])} "Sign Out"]])]
     [:div.row
      (cond
        (= false auth-required?)
        (main-panel)

        (= true loading?)
        (loading-panel)

        (and (= true authenticated?) (= true (:customizer_authorized user)))
        (main-panel)

        (and (= true authenticated?) (= false (:customizer_authorized user)))
        (unauthorized-panel)

        :else
        (login-panel))]
     [:div.row.mt-3.mb-1.justify-content-center
      [:p.small
       [:a.divided-text
        {:href "https://www.votinginfoproject.org/projects/get-to-the-polls/get-polls-privacy-policy/get-polls-terms-service/"
         :target "_blank"}
        "Terms of service"]
       [:a.mr-2
        {:href "https://www.votinginfoproject.org/projects/get-to-the-polls/get-polls-privacy-policy/" :target "_blank"}
        "Privacy"]
       "©2026 "
       [:a {:href "https://www.votinginfoproject.org/" :target "_blank"} "Voting Information Project"]]]]))
